export const ADD_COUPON_SUCCESS = "ADD_COUPON_SUCCESS";
export const LIST_ALL_COUPONS_SUCCESS = "LIST_ALL_COUPONS_REQUEST_SUCCESS";
export const UPDATE_COUPON_SUCCESS = "UPDATE_COUPON_SUCCESS";
export const LIST_ALL_COUPONS_REQUEST = "LIST_ALL_COUPONS_REQUEST";
export const LIST_ALL_COUPONS_FAILURE = "LIST_ALL_COUPONS_FAILURE";
export const DELETE_COUPON_SUCCESS = "DELETE_COUPON_SUCCESS";
export const CREATE_COUPON_SUCCESS = "CREATE_COUPON_SUCCESS";
export const LOADING_TRUE = "LOADING_TRUE";
export const LOADING_FALSE = "LOADING_FALSE";
